__turbopack_context__.v({
  "chosenEvaluation": "NUrc5q_chosenEvaluation",
  "details": "NUrc5q_details",
  "expanded": "NUrc5q_expanded",
  "impactContext": "NUrc5q_impactContext",
  "impactDetailsDescription": "NUrc5q_impactDetailsDescription",
  "impactDetailsExpandText": "NUrc5q_impactDetailsExpandText",
  "impactOutput": "NUrc5q_impactOutput",
  "overview": "NUrc5q_overview",
  "spacerRow": "NUrc5q_spacerRow",
  "wrapper": "NUrc5q_wrapper",
});
